/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import ContactView from "../views/ContactView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import InaugurationFormView from "@/views/InaugurationFormView.vue";
import InaugurationView from "@/views/InaugurationView.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "contact",
        component: ContactView,
    },
    {
        path: "/votre-duo-evenementiel",
        name: "home",
        component: HomeView,
    },
    {
        path: "/inauguration/inscription",
        name: "inauguration-form",
        component: InaugurationFormView,
    },
    {
        path: "/inauguration",
        name: "inauguration",
        component: InaugurationView,
    },
    {
        path: "/inauguration/done",
        name: "done-inauguration",
        redirect: (to) => {
            localStorage.fromty = true;
            return { name: "inauguration" };
        },
    },
    {
        path: "/404-not-found",
        name: "404",
        component: NotFoundView,
    },
    {
        path: "*",
        redirect: { name: "home" },
    },
];

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(
                    to.hash && to.hash != "#"
                        ? {
                            selector: to.hash,
                            offset: { x: 0, y: 0 },
                            behavior: "smooth",
                        }
                        : { x: 0, y: 0 }
                );
            }, 250);
        });
    },
});

export default router;
